module.exports = __webpack_public_path__ + "static/media/191.45de8f16.png";